import React from 'react';
import { Box, Collapse, Paper, Stack, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { neutral } from '_lex/_foundations/phxColors';

interface ConfigurationSectionProps {
  title: string;
  subtitle: string;
  children?: React.ReactNode;
  defaultExpanded?: boolean;
}

const ConfigurationSection: React.FC<ConfigurationSectionProps> = ({
  title,
  subtitle,
  children,
  defaultExpanded = false,
}) => {
  const [expanded, setExpanded] = React.useState(defaultExpanded);

  return (
    <Paper
      variant='outlined'
      sx={{
        borderColor: neutral[200],
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      <Box
        onClick={() => setExpanded((prev) => !prev)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: 6,
          py: 4,
          cursor: 'pointer',
          userSelect: 'none',
          '&:hover': {
            bgcolor: neutral[50],
          },
        }}
      >
        {expanded ? (
          <ExpandMoreIcon sx={{ color: neutral[500], flexShrink: 0 }} />
        ) : (
          <ChevronRightIcon sx={{ color: neutral[500], flexShrink: 0 }} />
        )}
        <Stack spacing={0.5}>
          <Typography
            variant='subtitleMd'
            sx={{ fontWeight: 600 }}
          >
            {title}
          </Typography>
          <Typography
            variant='bodyMd'
            color='text.secondary'
          >
            {subtitle}
          </Typography>
        </Stack>
      </Box>

      <Collapse in={expanded}>
        <Box
          sx={{
            borderTop: '1px solid',
            borderColor: neutral[200],
            p: 3,
          }}
        >
          {children}
        </Box>
      </Collapse>
    </Paper>
  );
};

export default ConfigurationSection;
